import { Span, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { Switch } from "@src/appV2/redesign/components/Switch";

interface ShowPriorityShiftsFilterProps {
  checked: boolean;
  onChange: (...event: any[]) => void;
}

export function ShowPriorityShiftsFilter(props: ShowPriorityShiftsFilterProps) {
  const { checked, onChange } = props;

  return (
    <Stack spacing={5} direction="row" justifyContent="space-between">
      <Stack spacing={2}>
        <Text semibold variant="body1">
          Include All Priority Access Shifts
        </Text>
        <Text variant="body2" sx={(theme) => ({ color: theme.palette.text.tertiary })}>
          Show all shifts, including those you can’t book
        </Text>
      </Stack>
      <Span sx={{ marginLeft: "auto" }}>
        <Switch
          aria-label="Include all Priority Access Shifts"
          checked={checked}
          onChange={onChange}
        />
      </Span>
    </Stack>
  );
}
